module.exports = __webpack_public_path__ + "static/media/brilliwhite-4.cb93967d.png";